import { render, staticRenderFns } from "./jiansuo.vue?vue&type=template&id=3ab45493&scoped=true&"
import script from "./jiansuo.vue?vue&type=script&lang=js&"
export * from "./jiansuo.vue?vue&type=script&lang=js&"
import style0 from "./jiansuo.vue?vue&type=style&index=0&id=3ab45493&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab45493",
  null
  
)

export default component.exports